import { createActions } from '@manager-base/app-base/config/data-access';
import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';

const actions = {
    getGlobal: {
        method: 'GET',
        url: `${BASE_PATH_API}/featureFlags/:flag(/:global)`,
        cache: true
    },
    retrieveFlag: {
        url: `${BASE_PATH_API}/external/featureFlags/:featureFlagKey`,
        method: 'GET',
        cache: true
    },
    getStickyFlag: {
        url: `${BASE_PATH_API}/external/stickyFeatureFlags/:featureFlagKey`,
        method: 'GET',
        cache: true
    },
    getRedirectedPage: {
        url: `${BASE_PATH_API}/featureFlags/redirectUrl`,
        method: 'GET',
        cache: true
    }
};

export function FeatureFlagsApi() {
    return createActions(actions);
}
